export default __webpack_public_path__ + "static/media/getting-started.ae5f3366.png";